var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmecis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.002C24.8366 32.002 32 24.8385 32 16.002C32 7.1654 24.8366 0.00195312 16 0.00195312C7.16344 0.00195312 0 7.1654 0 16.002C0 24.8385 7.16344 32.002 16 32.002Z",
    fill: "#1080FF",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28736 13.409C9.46488 13.1909 9.78738 13.162 10.0008 13.3452L15.1717 17.7837C15.3774 17.9603 15.405 18.2685 15.2339 18.4787L13.4013 20.731C12.7413 21.541 11.8113 22.051 10.7713 22.151C10.6413 22.161 10.5113 22.171 10.3813 22.171C9.49132 22.171 8.62132 21.861 7.92135 21.271C6.26134 19.901 6.02134 17.431 7.38134 15.751L9.28736 13.409Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7333 14.191L16.8082 16.5524C16.6303 16.7707 16.3072 16.799 16.094 16.6149L10.9311 12.1585C10.7263 11.9817 10.6993 11.6741 10.8701 11.4642L12.7133 9.201C13.3833 8.391 14.3133 7.89098 15.3533 7.791C16.3833 7.70099 17.4033 8.001 18.2033 8.67098C19.8633 10.041 20.1033 12.511 18.7333 14.191Z",
    fill: "#1080FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3012 16.2365C23.5652 16.3842 23.5897 16.74 23.3767 16.9548L18.2877 22.087C18.0725 22.3039 17.7125 22.2792 17.5648 22.0117C17.2287 21.4026 17.0391 20.7041 17.0391 19.969C17.0391 17.619 18.9391 15.709 21.2691 15.709C22.0054 15.709 22.6989 15.8992 23.3012 16.2365Z",
    fill: "#1080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4995 19.9698C25.4995 22.3198 23.5995 24.2298 21.2695 24.2298C20.6329 24.2298 20.0299 24.0895 19.4899 23.83C19.2081 23.6946 19.1729 23.325 19.3933 23.1031L24.3752 18.0871C24.599 17.8617 24.9753 17.8998 25.1088 18.188C25.361 18.7322 25.4995 19.3371 25.4995 19.9698Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmecis);
export default __webpack_public_path__ + "static/media/Pharmecis.440f712bdc8b96579484e7cd64c094e5.svg";
export { ForwardRef as ReactComponent };